import Feature from "ol/Feature";
import PointGeom from "ol/geom/Point";
import { Vector as VectorLayer } from "ol/layer";
import { fromLonLat } from "ol/proj";
import { Vector as VectorSource } from "ol/source";

import { layerStyles } from "@/gis/layer/styles";

export default class LocationLayer extends VectorLayer<any> {
  constructor() {
    const source = new VectorSource();
    const style = layerStyles["location"];

    super({
      source,
      style
    });
  }

  setLocation(longitude: number, latitude: number): void {
    this.removeLocation();
    const location = [longitude, latitude];
    (this as any).getSource().addFeature(new Feature(new PointGeom(fromLonLat(location))));
  }

  removeLocation(): void{
    (this as any).getSource().clear();
  }

}
